export default __webpack_public_path__ + "static/media/too_hard.fa1a5988.svg";